/**
 * Extract the language tag and raw code string from a ReactMarkdown
 * `pre` node. Works around HAST entity-encoding by reading from
 * the AST node directly when available.
 */
export function parseCodeBlock (children, node) {
  const codeElement = children?.props ? children : children?.[0]
  const className = codeElement?.props?.className || ''
  const hastCode = node?.children?.find(c => c.tagName === 'code')
  const rawText = hastCode?.children?.map(c => c.value || '').join('')
  const codeString = (rawText || String(codeElement?.props?.children || '')).replace(/\n$/, '')

  const match = /language-(.*)/.exec(className)
  const language = match ? match[1] : ''

  return { language, codeString }
}

/**
 * Returns true when a code block contains Abundance Engine JSX
 * (InlineChart / InlineTable) that should be rendered live.
 */
export function isAbundanceBlock (language, codeString) {
  return (
    language === 'jsx-abundance-engine' ||
    (language.startsWith('jsx') && (codeString.includes('<InlineChart') || codeString.includes('<InlineTable'))) ||
    (codeString.includes('<InlineChart') && codeString.includes('options={{')) ||
    codeString.includes('<InlineTable')
  )
}
